import { render, staticRenderFns } from "./top-up-success.vue?vue&type=template&id=58c1e72a&scoped=true"
import script from "./top-up-success.vue?vue&type=script&lang=js"
export * from "./top-up-success.vue?vue&type=script&lang=js"
import style0 from "./top-up-success.vue?vue&type=style&index=0&id=58c1e72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c1e72a",
  null
  
)

export default component.exports